import {
  CREATE_CIC_STATUS,
  DELETE_CIC_STATUS,
  EDIT_CIC_STATUS,
  RECEIVE_CIC_STATUSES,
  REQUEST_CIC_STATUS,
  REQUEST_CIC_STATUS_FOR_UNIT,
} from '@sophocles/entities/CicStatus/cicStatusActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_CIC_STATUSES: // Read
      return state.merge(action.cicStatuses);
    case DELETE_CIC_STATUS: // Delete
      return state.delete(action.cicStatus.toString());
    case EDIT_CIC_STATUS: // Update
    case CREATE_CIC_STATUS: // Create
    case REQUEST_CIC_STATUS:
    case REQUEST_CIC_STATUS_FOR_UNIT:
    default:
      return state;
  }
}

export function cicStatusReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_CIC_STATUS:
    case DELETE_CIC_STATUS:
    case RECEIVE_CIC_STATUSES:
    case EDIT_CIC_STATUS:
    case REQUEST_CIC_STATUS:
    case REQUEST_CIC_STATUS_FOR_UNIT:
      return getState(state, action);
    default:
      return state;
  }
}
